// pages/Dashboard.jsx
import TopRatedBooks from "../../components/home/TopRatedBooks";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <TopRatedBooks />
    </HomeLayout>
  );
}
